// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js!./extra-styles-bootstrap.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("231f6f18", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/utilities/extra-styles-bootstrap.css
// module id = 558
// module chunks = 0